import React, { useState, useRef, useEffect } from 'react';
import { Form, Segment, Transition } from 'semantic-ui-react';
import { SearchBar } from 'dyl-components';

import './index.scss';

const useOutsideClick = (ref, callback) => {
    const handleClick = e => {
      if (callback && ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };
  
    useEffect(() => {
      document.addEventListener("click", handleClick);
  
      return () => {
        document.removeEventListener("click", handleClick);
      };
    });
};

const TableDropdown = ({ 
    isSelectionVisible, 
    value, 
    searchPlaceholder = '', 
    onSearchAction, 
    onFocusAction, 
    onChange, 
    SelectionRender, 
    SearchResultsRender, 
    isSmall = false, 
    onChangeTeamsAndTerritories = null,
    isSeperateResults=false
}) => {
    const [state, setState] = useState({
        options: [],
        count: 0,
        search: '',
        open: false,
        isFocused: false
    });

    const ref = useRef();

    const [loading, setLoading] = useState(false);

    const searchFunction = async () => {
        try {
            setLoading(true);
            const { data, count, page=1 } = await onSearchAction(state.search);
            setLoading(false);
            setState({ ...state, options: data, count, open: true, page: page, search: state.search, isFocused: true });
        } catch (e) {
            setLoading(false);
        }
    }

    const onChangeSearch = (_, { value }) => {
        if(value.length > 1){
            setState({ ...state, search: value, isFocused: true });
        } else {
            setState({ ...state, isFocused: false });
        }
    }

    const cancelFunction = () => {
        setState({ ...state, options: [], count: 0, open: false, search: '', isFocused: false});
    }

    const onFocus = async () => {
        if(state.open){
            setState({ ...state, isFocused: true });
        } else {
            try {
                setLoading(true);
                const { data, count, page=1 } = await onFocusAction();
                setLoading(false);
                setState({ ...state, options: data, count, open: true, page: page, isFocused: true });
            } catch (e) {
                setLoading(false);
            }
        }
    }

    useOutsideClick(ref, cancelFunction);
    useOutsideClick(ref, onChangeTeamsAndTerritories);

    const results = <Transition visible={state.open} unmountOnHide={true} duration={0}>
        <SearchResultsRender results={state.options} count={state.count} value={value} onChange={onChange} isSmall={isSmall} setState={setState} setLoading={setLoading} state={state} loading={loading} />
    </Transition>;
    return (
        <div className='TableDropdownComponent' ref={ref}>
            <Segment.Group className='SegmentGroup'>
                <Segment onFocus={onFocus} onBlur={cancelFunction} className='SearchBarSegment'>
                    <Transition visible={isSelectionVisible}>
                        <SelectionRender areSelectionsRemovable={state.isFocused} value={value} onChange={onChange} page={state.page} />
                    </Transition>
                    <Form.Field
                        control={SearchBar}
                        addClassNames='SearchBarSegment__SearchInput'
                        isSearching={loading}
                        search={state.search}
                        searchFcn={searchFunction}
                        cancelFcn={cancelFunction}
                        placeholder={searchPlaceholder}
                        onChange={onChangeSearch}
                        dropdown
                    />
                </Segment>
                {!isSeperateResults && results}
            </Segment.Group>
            {isSeperateResults && results}
        </div>
    );
}

export default TableDropdown;
